export const state = {
  cutOff: {
    ignition: 27,
    engine: 61,
  },
}

export const getters = {
  getCutOffSensors: (state) => state.cutOff,
  getCutOffSensorCodes: (state) => Object.values(state.cutOff),
  getAllSensorCodes: (state) => [...Object.values(state.cutOff)],
}
